import { Box, Text } from 'wix-style-react';
import * as React from 'react';
export var SubtotalsListItem = function (_a) {
    var label = _a.label, value = _a.value, dataHook = _a.dataHook;
    return (React.createElement(Box, { paddingTop: "6px", paddingLeft: "4%", paddingRight: "4%", display: "flex", align: "space-between" },
        React.createElement(Text, { size: "tiny", dataHook: "".concat(dataHook, "-label") }, label),
        React.createElement(Text, { size: "tiny", dataHook: "".concat(dataHook, "-value") }, value)));
};
//# sourceMappingURL=SubtotalsListItem.js.map